import { render, staticRenderFns } from "./OrderListTabContent.vue?vue&type=template&id=3f1f72d6&scoped=true&"
import script from "./OrderListTabContent.vue?vue&type=script&lang=js&"
export * from "./OrderListTabContent.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTabContent.vue?vue&type=style&index=0&id=3f1f72d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f72d6",
  null
  
)

export default component.exports